import { render, staticRenderFns } from "./TypeThreshold.vue?vue&type=template&id=3b20b916&scoped=true"
import script from "./TypeThreshold.vue?vue&type=script&lang=ts"
export * from "./TypeThreshold.vue?vue&type=script&lang=ts"
import style0 from "./TypeThreshold.vue?vue&type=style&index=0&id=3b20b916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b20b916",
  null
  
)

export default component.exports